import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-skeleton-detail',
    template: `
        <div class="skeleton-detail-wrapper">
            <!-- 1. Hero Identity Card Shimmer -->
            <div class="sk-identity-card" *ngIf="showHero">
                <div class="sk-identity-main">
                    <!-- Avatar Circle -->
                    <div class="sk-avatar-circle skeleton-shimmer"></div>

                    <!-- Info Meta Lines -->
                    <div class="sk-info-stack">
                        <div class="sk-name-line skeleton-shimmer"></div>
                        <div class="sk-sub-line skeleton-shimmer"></div>
                        <div class="sk-tags-row">
                            <div class="sk-tag-pill skeleton-shimmer"></div>
                            <div class="sk-tag-pill skeleton-shimmer"></div>
                            <div class="sk-tag-pill skeleton-shimmer"></div>
                        </div>
                    </div>
                </div>

                <!-- Stats Metric Chips -->
                <div class="sk-stats-grid" *ngIf="showStats">
                    <div class="sk-stat-card" *ngFor="let s of [1, 2, 3, 4]">
                        <div class="sk-stat-val skeleton-shimmer"></div>
                        <div class="sk-stat-label skeleton-shimmer"></div>
                    </div>
                </div>
            </div>

            <!-- 2. Navigation Tabs Bar Shimmer -->
            <div class="sk-tabs-bar" *ngIf="showTabs">
                <div class="sk-tab-item skeleton-shimmer" *ngFor="let t of tabList" [style.width]="t"></div>
            </div>

            <!-- 3. Active Tab Content Pane Shimmer -->
            <div class="sk-content-card">
                <!-- Title Row -->
                <div class="sk-pane-header">
                    <div class="sk-pane-title skeleton-shimmer"></div>
                    <div class="sk-pane-subtitle skeleton-shimmer"></div>
                </div>

                <!-- Form / Grid Fields Shimmer -->
                <div class="sk-fields-grid">
                    <div class="sk-field-item" *ngFor="let f of [1, 2, 3, 4, 5, 6]">
                        <div class="sk-field-label skeleton-shimmer"></div>
                        <div class="sk-field-box skeleton-shimmer"></div>
                    </div>
                </div>
            </div>
        </div>
    `,
    styles: [`
        .skeleton-detail-wrapper {
            display: flex;
            flex-direction: column;
            gap: 1.25rem;
            width: 100%;
        }

        .sk-identity-card {
            background: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 16px;
            padding: 1.75rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 1.5rem;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
            flex-wrap: wrap;

            :host-context(.dark) & {
                background: #0f172a;
                border-color: #334155;
            }
        }

        .sk-identity-main {
            display: flex;
            align-items: center;
            gap: 1.5rem;

            .sk-avatar-circle {
                width: 88px;
                height: 88px;
                border-radius: 50%;
                flex-shrink: 0;
            }

            .sk-info-stack {
                display: flex;
                flex-direction: column;
                gap: 0.5rem;

                .sk-name-line {
                    width: 220px;
                    height: 22px;
                    border-radius: 6px;
                }

                .sk-sub-line {
                    width: 160px;
                    height: 14px;
                    border-radius: 4px;
                }

                .sk-tags-row {
                    display: flex;
                    gap: 0.4rem;
                    margin-top: 0.25rem;

                    .sk-tag-pill {
                        width: 75px;
                        height: 22px;
                        border-radius: 9999px;
                    }
                }
            }
        }

        .sk-stats-grid {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            flex-wrap: wrap;

            .sk-stat-card {
                background: #f8fafc;
                border: 1px solid #e2e8f0;
                border-radius: 10px;
                padding: 0.65rem 1rem;
                display: flex;
                flex-direction: column;
                gap: 0.35rem;
                min-width: 90px;

                .sk-stat-val {
                    height: 18px;
                    width: 45px;
                    border-radius: 4px;
                }

                .sk-stat-label {
                    height: 10px;
                    width: 65px;
                    border-radius: 3px;
                }

                :host-context(.dark) & {
                    background: #111c38;
                    border-color: #1e2d52;
                }
            }
        }

        .sk-tabs-bar {
            display: flex;
            gap: 0.5rem;
            overflow-x: auto;
            padding-bottom: 0.25rem;

            .sk-tab-item {
                height: 40px;
                border-radius: 10px;
                flex-shrink: 0;
            }
        }

        .sk-content-card {
            background: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 14px;
            padding: 1.5rem;
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

            :host-context(.dark) & {
                background: #0f172a;
                border-color: #334155;
            }
        }

        .sk-pane-header {
            display: flex;
            flex-direction: column;
            gap: 0.35rem;
            border-bottom: 1px solid #e2e8f0;
            padding-bottom: 1rem;

            .sk-pane-title {
                height: 18px;
                width: 200px;
                border-radius: 4px;
            }

            .sk-pane-subtitle {
                height: 12px;
                width: 320px;
                border-radius: 4px;
            }

            :host-context(.dark) & {
                border-color: #1e2d52;
            }
        }

        .sk-fields-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 1.25rem;

            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }

            .sk-field-item {
                display: flex;
                flex-direction: column;
                gap: 0.4rem;

                .sk-field-label {
                    height: 12px;
                    width: 90px;
                    border-radius: 3px;
                }

                .sk-field-box {
                    height: 38px;
                    width: 100%;
                    border-radius: 8px;
                }
            }
        }
    `]
})
export class SkeletonDetailComponent {
    @Input() showHero: boolean = true;
    @Input() showStats: boolean = true;
    @Input() showTabs: boolean = true;
    @Input() tabCount: number = 8;

    get tabList(): string[] {
        const widths = ['110px', '130px', '120px', '140px', '125px', '135px', '115px', '100px'];
        return widths.slice(0, this.tabCount);
    }
}
